var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPlaceholder = function SvgIconPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.234 4.331v16.562l10.767 3.857V8.044l11.612-4.27L12.073 0 .234 4.331Z",
    fill: "#00E599"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.867 8.662v8.93l10.746 3.837V4.682l-10.746 3.98Z",
    fill: "#00AF92"
  })));
};
export default SvgIconPlaceholder;